import { render, staticRenderFns } from "./TipTap.vue?vue&type=template&id=6ad4cad7&scoped=true&"
import script from "./TipTap.vue?vue&type=script&lang=js&"
export * from "./TipTap.vue?vue&type=script&lang=js&"
import style0 from "./TipTap.vue?vue&type=style&index=0&id=6ad4cad7&prod&lang=css&"
import style1 from "./TipTap.vue?vue&type=style&index=1&id=6ad4cad7&prod&lang=css&"
import style2 from "./TipTap.vue?vue&type=style&index=2&id=6ad4cad7&prod&scoped=true&lang=css&"
import style3 from "./TipTap.vue?vue&type=style&index=3&id=6ad4cad7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad4cad7",
  null
  
)

export default component.exports